(function () {
    'use strict';

    angular
        .module('admin')
        .controller('FindClientsExpoController', FindClientsExpoController)

    FindClientsExpoController.$inject = ['$state', '$stateParams','clients','FindClientsService'];


    function FindClientsExpoController($state, $stateParams, clients, FindClientsService) {
        var vm = this;

      
        vm.expoInstitutions             = '';
        vm.expoVirtualInstitution       = '';
        vm.webinars                     = '';
        
        vm.getExpoInstitution           = getExpoInstitution;
        vm.getExpoVirtualInstitution    = getExpoVirtualInstitution;
        vm.getWebinars                  = getWebinars;
        vm.getInformation               = getInformation;
        vm.remove                       = remove;


        function activate() {

        }


        function getExpoInstitution() {
            vm.expoInstitutions = '';
            var institution_id = $stateParams.id;
            FindClientsService.getExpoInstitution(institution_id).then(function(response){
                vm.expoInstitutions = response.data;
            }).catch(function(err) {

            });
        }

        function getExpoVirtualInstitution(institution_id) {
            FindClientsService.getExpoVirtualInstitution(institution_id).then(function(response){
                vm.expoVirtualInstitution = response.data;
            }).catch(function(err) {

            });
        }

        function getWebinars(institution_id) {
            FindClientsService.getWebinars(institution_id).then(function(response){
                vm.webinars = response.data;
            }).catch(function(err) {

            });
        }

        function getInformation(institution_id) {
             vm.getExpoInstitution(institution_id);
        }

        function remove() {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this user ' +  '?')
                .set('onok', function () {
                })
                .show();
        }

        activate();
    }

})();